import styled from 'styled-components';
import { flexPosition } from '../../../../styles/mixins';

export const ButtonsContainer = styled.div`
  ${flexPosition({ align: 'center', justify: 'space-between' })}
  padding: 10px;
  width: 100%;
  position: relative;
  &::before {
    content: '';
    position: absolute;
    height: 40px;
    top: -40px;
    left: 0px;
    width: 100%;
    background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.1), #ffffff);
  }
`;



// WEBPACK FOOTER //
// ./src/components/ProductAddons/CustomSteps/AddStepDataButtons/style.js